import createReactClass from 'create-react-class';
import PropTypes from 'prop-types';
import PureRenderMixin from '../common/external-adapters/pureRenderMixinAdapter.js';
import { addCommas } from '../utils/numberUtils.ts';
import { getURLParam } from '../adapters/dupes/queryParams.js';
import { schoolSearchOnly, teacherSearchOnly } from '../common/searchRequestUtils.js';
import { DropdownMenu } from '../common/DropdownMenu.js';
import { isValidZip } from '../utils/addressUtils.ts';

const SortSelector = createReactClass({
    propTypes: {
        projects: PropTypes.object.isRequired,
        searchURL: PropTypes.string.isRequired,
        sortOptions: PropTypes.array.isRequired,
        callbacks: PropTypes.object.isRequired,
        isMobile: PropTypes.bool.isRequired,
    },

    mixins: [PureRenderMixin],

    render: function () {
        const props = this.props;

        // Legacy zip sort overrides other sorts
        const isKeywordZipSort = props.projects.breadcrumb &&
            props.projects.breadcrumb.some(function (crumb) {
                return crumb[0] === 'keywords' && isValidZip(crumb[1]);
            });
        const schoolsOnly = schoolSearchOnly(props.searchURL);
        const teachersOnly = teacherSearchOnly(props.searchURL);
        const totalProposals = props.projects.totalProposals;
        const noProjects = !totalProposals;
        const historical = new Uri(props.searchURL).hasQueryParam('historical', 'true');

        if (isKeywordZipSort || schoolsOnly || teachersOnly || noProjects) {
            return null;
        }

        const projectCount = (
            <span>
                {/* eslint-disable-next-line eqeqeq */}
                <strong>{addCommas(totalProposals)}</strong> project{totalProposals != '1' ? 's' : ''}
            </span>
        );

        const hideSort = totalProposals < 2 || historical;
        if (hideSort) {
            return <div className="sort-projects select-with-dropdown">{projectCount}</div>;
        }

        const selectedSort = getURLParam(props.searchURL, 'sortBy') || 0;

        const handleSelect = function (value) {
            props.callbacks.applyFilters({
                sortBy: value,
            });
        };

        const label = <span>{projectCount} sorted by</span>;

        return <DropdownMenu label={label} options={props.sortOptions} select={handleSelect}
            mainClass="sort-projects select-with-dropdown" optionsClass="dropdown-options"
            selectedValue={selectedSort} ariaLabel="List with sort options" />;
    },
});

export default SortSelector;
